<template>
  <Draggable v-bind="$attrs" v-on="$listeners">
    <slot />
  </Draggable>
</template>

<script>
import Draggable from 'vuedraggable'

export default {
  name: 'SortableList',
  inheritAttrs: false,
  components: {
    Draggable
  }
}
</script>
